import {
  BrowserMethodsDataType,
  BrowserMethodsInterface,
  BrowserInteraction,
  ObjectSimpleType
} from './types'

function BrowserMethods(instanceName: string): BrowserMethodsInterface {
  const instance = window.nr[instanceName]

  function setCustomAttribute<T>(
    key: string,
    value: BrowserMethodsDataType<T>
  ): void {
    instance?.setCustomAttribute(key, value as any)
  }

  function pageAction<T>(
    string: string,
    data: BrowserMethodsDataType<T>
  ): void {
    console.log(instanceName, string)
    instance?.addPageAction(string, data as any)
  }

  function setReleaseID(appName: string, version: string): void {
    instance?.addRelease(appName, version)
  }

  function setUserInfo<T>(userData: ObjectSimpleType<T>): void {
    Object.entries(userData).forEach(([key, value]) => {
      instance?.setCustomAttribute(key, value as newrelic.SimpleType)
    })
  }

  function noticeError<T = Error>(error: T): void {
    instance?.noticeError(error as any)
  }

  function finished(timestamp?: number): void {
    instance?.finished(timestamp)
  }

  function getInteraction(): BrowserInteraction {
    return instance?.interaction()
  }

  function setCurrentRouteName(name: string): void {
    instance?.setCurrentRouteName(name)
  }

  function setPageViewName(name: string, host?: string): void {
    instance?.setPageViewName(name, host)
  }

  function setErrorHandler(handler: (error: Error) => void): void {
    instance?.setErrorHandler(handler as newrelic.ErrorHandler)
  }

  const interaction = getInteraction()

  return {
    setCustomAttribute,
    pageAction,
    setReleaseID,
    setUserInfo,
    noticeError,
    finished,
    setCurrentRouteName,
    setPageViewName,
    setErrorHandler,
    interaction
  }
}

export { BrowserMethods }
